// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"6cbab446","16":"70e413ba","300":"fcb718a4","453":"127be8e2","597":"6d2a73b4","652":"ae9971cd","890":"78717a8a","975":"8de2069e"}[chunkId] + ".chunk.js";
};